var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtternityMobile6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 180,
    viewBox: "0 0 158 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_336_1575)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_336_1575",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -2,
    width: 158,
    height: 180
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -2,
    width: 158,
    height: 180,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_336_1575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0166 0.700723C40.6134 2.27757 37.3956 5.14079 35.2364 9.45636C34.1779 11.5726 34.0932 12.1536 33.9662 18.2535C33.7969 24.3534 33.8392 24.7683 34.686 25.5983C35.8291 26.7187 38.6235 26.8016 39.7666 25.6813C40.4017 25.0588 40.571 24.0629 40.7404 19.7888C40.9944 14.0624 41.5448 12.1951 43.7465 9.95431C44.5085 9.16589 45.8634 8.16999 46.7948 7.67203L48.4884 6.75913H87.6517C130.837 6.75913 128.678 6.63464 131.811 9.41486C134.478 11.7386 135.156 13.7719 135.41 19.7888C135.579 24.0629 135.748 25.0588 136.384 25.6813C137.527 26.8016 140.321 26.7187 141.464 25.5983C142.311 24.7683 142.353 24.3534 142.184 18.2535C142.057 12.0291 142.015 11.6141 140.829 9.24888C139.22 6.05369 136.002 2.90001 132.742 1.32316L130.202 0.11978L88.7102 0.0367885C49.0811 -0.0462033 47.1336 -0.0462033 45.0166 0.700723Z",
    fill: "url(#paint0_linear_336_1575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3736 14.021C74.8232 14.5604 74.5269 15.3903 74.5269 16.5107C74.5269 17.6311 74.8232 18.461 75.3736 19.0005C76.1781 19.7889 76.7708 19.8304 88.0752 19.8304C99.3797 19.8304 99.9724 19.7889 100.777 19.0005C101.327 18.461 101.624 17.6311 101.624 16.5107C101.624 15.3903 101.327 14.5604 100.777 14.021C99.9724 13.2325 99.3797 13.191 88.0752 13.191C76.7708 13.191 76.1781 13.2325 75.3736 14.021Z",
    fill: "url(#paint1_linear_336_1575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.692 33.939C18.936 37.8811 4.6255 51.9068 0.857359 70.0405C-0.285786 75.6009 -0.285786 83.5681 0.857359 89.1286C4.66784 107.345 19.0207 121.412 37.9037 125.272C43.1961 126.35 51.6215 126.35 57.1678 125.23C75.7545 121.495 90.1074 107.428 94.0449 88.9211C95.1457 83.8171 95.1457 75.3519 94.0449 70.2479C90.1074 51.7408 75.7545 37.6737 57.1678 33.939C51.7061 32.8601 42.8574 32.8601 37.692 33.939ZM54.3735 40.6199C69.065 42.9436 81.6396 54.023 86.2545 68.6711C87.313 72.0323 87.3977 72.8622 87.3977 79.5845C87.3977 86.3484 87.313 87.0953 86.2122 90.5809C84.8997 94.7305 82.444 99.627 80.0731 102.739L78.5065 104.856L77.7021 103.403C75.7969 99.9175 70.5045 95.7264 65.8473 93.9836C63.434 93.1122 62.6719 93.0707 48.319 92.9462C33.8815 92.8217 33.2465 92.8632 30.1981 93.7346C25.0328 95.27 19.317 99.5026 17.1578 103.403L16.3533 104.856L14.7868 102.739C12.3735 99.5855 9.91784 94.689 8.64768 90.5809C7.29284 86.0164 6.78478 78.0077 7.63155 73.1112C9.96018 58.8366 20.9682 46.3878 35.1517 41.9062C41.5025 39.9144 47.2606 39.541 54.3735 40.6199ZM59.4541 99.876C64.8311 100.581 69.7001 103.818 72.1981 108.383L73.0449 109.918L71.8594 110.914C68.7263 113.611 61.6557 116.765 56.1094 118.01C51.4945 119.047 43.3654 119.047 38.7505 118.01C33.2041 116.765 26.1336 113.611 23.0005 110.914L21.815 109.918L22.6618 108.383C25.0328 103.984 30.1134 100.54 35.0247 99.9175C38.5388 99.4611 55.9824 99.4611 59.4541 99.876Z",
    fill: "url(#paint2_linear_336_1575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6294 53.8155C37.1839 55.4339 34.0085 58.2556 31.8492 62.5712C30.7907 64.646 30.7061 65.2684 30.7061 69.6255C30.7061 74.0655 30.7907 74.5635 31.9339 76.8873C33.5427 80.0824 36.7605 83.2361 40.0206 84.813C42.3915 85.9334 42.8996 86.0164 47.4298 86.0164C51.9601 86.0164 52.4682 85.9334 54.8391 84.813C58.0992 83.2361 61.3169 80.0824 62.9258 76.8873C64.069 74.5635 64.1536 74.0655 64.1536 69.6255C64.1536 65.1854 64.069 64.6875 62.9258 62.3637C61.3169 59.1685 58.0992 56.0148 54.8391 54.4795C52.6375 53.4006 51.7484 53.2346 48.0649 53.1101C44.7202 53.0271 43.3653 53.1931 41.6294 53.8155ZM51.1557 60.7454C54.7544 62.1977 57.1677 65.7249 57.1677 69.6255C57.1677 74.9784 52.8915 79.1695 47.4298 79.1695C41.9682 79.1695 37.6919 74.9784 37.6919 69.6255C37.6919 65.8908 39.8512 62.6127 43.4077 60.7868C45.0589 59.9154 49.1234 59.9154 51.1557 60.7454Z",
    fill: "url(#paint3_linear_336_1575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.526 33.9805C111.615 35.8478 108.397 40.7443 108.397 46.3878C108.397 51.7822 111.107 56.1808 115.807 58.4216L117.924 59.459L141.676 59.5835C165.004 59.6664 165.512 59.6664 167.841 58.795C178.891 54.7699 178.891 38.0056 167.883 33.9805C165.597 33.1506 164.835 33.1091 142.141 33.1506C119.702 33.1506 118.686 33.1921 116.526 33.9805ZM165.555 40.8273C170.085 43.4415 170.085 49.334 165.555 51.9482C164.115 52.7781 163.522 52.8196 142.268 52.8196C121.014 52.8196 120.422 52.7781 118.982 51.9482C113.647 48.919 114.791 41.5742 120.803 40.1219C121.522 39.9559 131.599 39.8314 143.115 39.8729C163.438 39.9559 164.115 39.9974 165.555 40.8273Z",
    fill: "url(#paint4_linear_336_1575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.511 66.8867C135.706 67.4677 135.706 68.671 135.494 125.935C135.283 184.113 135.283 184.362 134.394 186.229C133.335 188.47 130.71 190.918 128.466 191.665C126.011 192.536 50.1396 192.536 47.6839 191.665C45.44 190.918 42.815 188.47 41.7565 186.229C40.9097 184.403 40.8674 183.615 40.6557 159.132C40.444 134.733 40.4017 133.861 39.6396 133.28C38.3694 132.409 35.7444 132.533 34.7283 133.529C33.8815 134.359 33.8392 134.733 33.9662 160.833L34.0932 187.266L35.321 189.756C36.9299 192.951 40.1476 196.105 43.4077 197.682L45.9481 198.885H88.0751H130.202L132.742 197.682C136.002 196.105 139.22 192.951 140.829 189.756C142.057 187.308 142.057 187.183 142.184 179.092C142.311 171.041 142.353 170.958 143.158 171.747C143.835 172.411 144.597 172.535 148.535 172.535C154.25 172.535 154.293 172.494 155.648 166.435C156.198 164.029 156.706 161.995 156.791 161.954C156.833 161.912 158.442 161.29 160.347 160.543L163.861 159.174L167.587 161.497C173.176 164.942 173.472 164.9 179.019 159.547C181.432 157.223 183.718 154.734 184.015 153.987C184.734 152.327 184.438 151.414 181.559 147.14L179.442 143.903L180.839 140.5C181.601 138.592 182.279 137.015 182.321 136.932C182.363 136.849 184.48 136.351 187.021 135.77C193.287 134.401 193.075 134.774 193.075 125.852C193.075 119.421 192.99 118.632 192.313 118.01C191.847 117.636 189.476 116.889 186.936 116.308C184.438 115.769 182.363 115.271 182.321 115.188C182.279 115.105 181.601 113.528 180.839 111.661L179.442 108.258L181.728 104.606C183.041 102.615 184.184 100.623 184.311 100.208C184.819 98.7971 183.464 96.8053 179.019 92.5312C173.472 87.2197 173.176 87.1782 167.587 90.6224L163.819 92.9461L160.347 91.5768C158.442 90.8299 156.833 90.1659 156.791 90.1659C156.706 90.1244 156.198 88.0911 155.648 85.6844C154.293 79.626 154.25 79.5845 148.535 79.5845C144.513 79.5845 143.877 79.6675 143.115 80.4144L142.269 81.2443V74.605C142.269 68.5051 142.184 67.8826 141.422 67.1357C140.406 66.1398 137.738 66.0153 136.511 66.8867ZM146.206 86.2238H148.45L149.255 90.2074C149.678 92.4067 150.398 94.6475 150.821 95.1454C151.244 95.7264 152.769 96.4733 154.377 97.0127C155.944 97.5107 158.527 98.5481 160.093 99.3365C161.702 100.125 163.438 100.747 163.988 100.747C164.539 100.747 165.894 100.166 167.079 99.461C168.222 98.7141 169.831 97.7182 170.678 97.1787L172.202 96.2243L174.15 98.1746L176.055 100.125L173.769 103.611C172.498 105.561 171.482 107.553 171.482 108.092C171.482 108.632 172.117 110.333 172.922 111.868C173.684 113.404 174.742 115.852 175.25 117.346C175.759 118.84 176.309 120.25 176.478 120.499C176.986 121.288 178.341 121.786 182.194 122.533L185.877 123.28V126.06V128.84L182.194 129.587C178.341 130.334 176.986 130.832 176.478 131.62C176.309 131.869 175.759 133.28 175.25 134.774C174.742 136.268 173.684 138.716 172.922 140.251C172.117 141.787 171.482 143.488 171.482 144.028C171.482 144.567 172.498 146.559 173.769 148.509L176.055 151.995L174.15 153.945L172.202 155.895L170.678 154.941C169.831 154.402 168.222 153.406 167.079 152.659C165.894 151.953 164.539 151.372 163.988 151.372C163.438 151.372 161.702 151.995 160.093 152.783C158.527 153.572 155.944 154.609 154.377 155.107C152.769 155.646 151.244 156.393 150.821 156.974C150.398 157.472 149.678 159.713 149.255 161.912L148.45 165.896H146.206C144.513 165.896 143.75 166.103 143.115 166.726L142.269 167.556L142.353 140.5L142.48 113.404L146.079 113.445C150.228 113.445 152.218 114.234 154.97 116.931C157.849 119.753 158.569 121.537 158.569 126.06C158.569 129.131 158.4 130.334 157.765 131.454C156.325 134.11 154.462 136.06 152.218 137.305C149.763 138.675 148.831 140.168 149.297 141.994C149.593 143.281 151.329 144.733 152.557 144.733C155.055 144.733 160.559 140.625 162.93 136.932C166.825 130.998 167.079 122.076 163.523 116.101C159.797 109.752 153.361 106.142 145.825 106.142H142.269V95.3529V84.564L143.115 85.3939C143.75 86.0163 144.513 86.2238 146.206 86.2238Z",
    fill: "url(#paint5_linear_336_1575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6599 139.38C13.7284 140.086 13.5591 140.583 13.5591 142.202C13.5591 144.36 14.2365 145.314 16.1841 145.77C18.428 146.31 20.2909 144.609 20.3333 141.953C20.3333 140.583 20.1216 140.044 19.2325 139.38C18.5974 138.882 17.5813 138.509 16.9462 138.509C16.3111 138.509 15.295 138.882 14.6599 139.38Z",
    fill: "url(#paint6_linear_336_1575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0509 140.168C54.5005 140.708 54.2041 141.538 54.2041 142.658C54.2041 143.779 54.5005 144.609 55.0509 145.148C55.8976 145.978 56.4481 145.978 88.0751 145.978C119.702 145.978 120.252 145.978 121.099 145.148C121.65 144.609 121.946 143.779 121.946 142.658C121.946 141.538 121.65 140.708 121.099 140.168C120.252 139.339 119.702 139.339 88.0751 139.339C56.4481 139.339 55.8976 139.339 55.0509 140.168Z",
    fill: "url(#paint7_linear_336_1575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6599 152.659C13.7284 153.364 13.5591 153.862 13.5591 155.481C13.5591 157.638 14.2365 158.593 16.1841 159.049C18.428 159.589 20.2909 157.887 20.3333 155.232C20.3333 153.862 20.1216 153.323 19.2325 152.659C18.5974 152.161 17.5813 151.787 16.9462 151.787C16.3111 151.787 15.295 152.161 14.6599 152.659Z",
    fill: "url(#paint8_linear_336_1575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0509 153.447C54.5005 153.987 54.2041 154.817 54.2041 155.937C54.2041 157.057 54.5005 157.887 55.0509 158.427C55.8553 159.215 56.4481 159.257 71.1396 159.257C85.8311 159.257 86.4239 159.215 87.2283 158.427C87.7787 157.887 88.0751 157.057 88.0751 155.937C88.0751 154.817 87.7787 153.987 87.2283 153.447C86.4239 152.659 85.8311 152.617 71.1396 152.617C56.4481 152.617 55.8553 152.659 55.0509 153.447Z",
    fill: "url(#paint9_linear_336_1575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6599 165.937C13.7284 166.643 13.5591 167.141 13.5591 168.759C13.5591 170.917 14.2365 171.871 16.1841 172.328C18.428 172.867 20.2909 171.166 20.3333 168.51C20.3333 167.141 20.1216 166.601 19.2325 165.937C18.5974 165.439 17.5813 165.066 16.9462 165.066C16.3111 165.066 15.295 165.439 14.6599 165.937Z",
    fill: "url(#paint10_linear_336_1575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0509 166.726C54.5005 167.265 54.2041 168.095 54.2041 169.216C54.2041 170.336 54.5005 171.166 55.0509 171.705C55.8976 172.535 56.4481 172.535 81.3009 172.535C106.154 172.535 106.704 172.535 107.551 171.705C108.101 171.166 108.398 170.336 108.398 169.216C108.398 168.095 108.101 167.265 107.551 166.726C106.704 165.896 106.154 165.896 81.3009 165.896C56.4481 165.896 55.8976 165.896 55.0509 166.726Z",
    fill: "url(#paint11_linear_336_1575)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_336_1575",
    x1: 141.865,
    y1: 26.6183,
    x2: 93.3393,
    y2: -44.3377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_336_1575",
    x1: 101.524,
    y1: 19.8648,
    x2: 89.3452,
    y2: 2.10613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_336_1575",
    x1: 94.5217,
    y1: 126.557,
    x2: -23.1336,
    y2: 83.6503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_336_1575",
    x1: 64.0307,
    y1: 86.1869,
    x2: 22.5036,
    y2: 71.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_336_1575",
    x1: 175.885,
    y1: 59.7551,
    x2: 124.029,
    y2: 12.3584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_336_1575",
    x1: 192.491,
    y1: 199.572,
    x2: 3.60028,
    y2: 118.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_336_1575",
    x1: 20.3084,
    y1: 145.908,
    x2: 11.7185,
    y2: 143.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_336_1575",
    x1: 121.697,
    y1: 146.012,
    x2: 115.036,
    y2: 121.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_336_1575",
    x1: 20.3084,
    y1: 159.187,
    x2: 11.7185,
    y2: 156.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_336_1575",
    x1: 87.9505,
    y1: 159.291,
    x2: 76.9395,
    y2: 139.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_336_1575",
    x1: 20.3084,
    y1: 172.466,
    x2: 11.7185,
    y2: 169.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_336_1575",
    x1: 108.198,
    y1: 172.57,
    x2: 100.187,
    y2: 149.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_1575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 180,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtternityMobile6);
export default __webpack_public_path__ + "static/media/Atternity_mobile6.726b58a19d7c3ea3f7bff999a6065cda.svg";
export { ForwardRef as ReactComponent };